import { render } from "./BlacklistsComponent.vue?vue&type=template&id=42e87ab2&scoped=true"
import script from "./BlacklistsComponent.vue?vue&type=script&lang=js"
export * from "./BlacklistsComponent.vue?vue&type=script&lang=js"

import "./BlacklistsComponent.vue?vue&type=style&index=0&id=42e87ab2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42e87ab2"]])

export default __exports__